var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"agreement_page"},[_c('new-header',{attrs:{"config":_vm.headerConfig}}),_c('img',{staticClass:"agreement_image",attrs:{"src":_vm.urlData,"alt":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }